import React from 'react';
import { toFormatPrice } from '../../common/helpers/function';

export const QuotationDetailsSubtable = (prioritydata, id, t) => {
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const rows = Array.isArray(prioritydata?.data)
    ? prioritydata.data
    : Object.values(prioritydata?.data || {});

  return (
    <React.Fragment>
      {prioritydata.code === 200 ? (
        <tr
          className="common-sub-table-wrap add-row remove"
          id={`common-sub-table-wrap-${id}`}
        >
          <td colSpan="14">
            <table
              id={`data_subtable_quotation_${id}`}
              className="common-table common-sub-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t('Ref No.')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('SKU')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Stock ID')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Metal')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Stone')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Size')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Qty')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Amount')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Payment')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                  <th>{t('Delivery Date')}
                    <div className="up-down-arrow-btn">
                      <img className="up-down-arrow-img up-down-arrow-img-forward active" src={base_assets + 'images/icons/up-down-arrow-green.png'} alt="" />
                      <img className="up-down-arrow-img up-down-arrow-img-reverse" src={base_assets + 'images/icons/up-down-arrow-green-reverse.png'} alt="" />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((result, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{result?.Refno || result?.linked_order_no || '-'}</td>
                    <td>{result?.SKU || '-'}</td>
                    <td>{result?.stock_id || '-'}</td>
                    <td>{result?.metal_name || '-'}</td>
                    <td>{result?.stone_name || '-'}</td>
                    <td>{result?.size_name || '-'}</td>
                    <td>{result?.qty ?? '-'}</td>
                    <td>{toFormatPrice(result?.amount, { addSymbol: true })}</td>
                    <td>{toFormatPrice(result?.payment, { addSymbol: true })}</td>
                    <td>{result?.delivery_date || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default QuotationDetailsSubtable;
